module.exports = __webpack_public_path__ + "static/media/person.f540a12d.png";